const ACCESS_TOKEN = "ACCESS_TOKEN";

const setLocalStorage = (name, value) => localStorage.setItem(name, value);

const getLocalStorage = (name) => localStorage.getItem(name);

const removeLocalStorage = (name) => localStorage.removeItem(name);

export { setLocalStorage, getLocalStorage, removeLocalStorage, ACCESS_TOKEN };
